export default "/images/viber.svg?d181e2ddc550ff41d4028c0ce0f69a1f";